module.exports = __webpack_public_path__ + "static/media/editSimpleGrey.8c7818e5.svg";